import { useRouter } from 'next/navigation'
import type { FC } from 'react'
import { Trans } from 'react-i18next'

import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'

import type { INotification, INotificationProfile } from '~/lib/features/notifications/types'

import NotificationItemLayout from './NotificationItemLayout'
import { AI_INTERVIEWS_TAB, INTERVIEWS_TAB } from '~/lib/features/candidates/utilities/enum'

const CandidateCompleteAIInterview: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const router = useRouter()
  const propertiesRelated = notification?.payload as INotificationProfile

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      recipient={notification.recipient}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              onClick && onClick()
              router.push(
                `${configuration.path.candidates.detail(
                  propertiesRelated.profileId,
                  propertiesRelated.applicantId
                )}?profile-tabs=${INTERVIEWS_TAB}&interview_tabs=${AI_INTERVIEWS_TAB}`
              )
            }}>
            <Trans
              i18nKey="activity:notification:candidateCompleteAIInterview"
              values={{
                candidateName: propertiesRelated.profileFullName,
                ikitTemplateName: propertiesRelated?.ikitTemplateName
              }}>
              <span className="font-medium text-gray-900" />
            </Trans>
            {time}
          </TypographyText>
        </>
      )}
    </NotificationItemLayout>
  )
}

export default CandidateCompleteAIInterview
